<template>
  <div
    v-if="product.product"
    data-test-id="merge-cart-item"
    :class="[
      $style['cart-item'],
      { [$style['cart-item--faded']]: forgetProducts.includes(product.pId) }
    ]">
    <div v-if="!noImage" :class="$style['cart-item__image']">
      <img :src="imageUrl">
    </div>

    <div :class="$style['cart-item__content']">
      <grid>
        <cell
          size="9"
          :class="$style['cart-item__content-container']">
          <div v-if="product.product?.tags.includes('hiddengoodie')">
            <b>{{ product.product?.title }}</b>
          </div>
          <NuxtLink
            v-else
            :no-prefetch="true"
            :to="getProductRoute({product: product.product, lang: $lang})">
            <b>
              <span
                v-if="product.quantity > 1">{{ product.quantity }} x</span>
              {{ product.product?.title }}
            </b>
          </NuxtLink>

          <div class="h-color-grey-dark">
            {{ product.product?.colorName }} -
            {{ product.product?.sizes?.filter(size => size.pId === product.pId)[0].size }}
          </div>
          <div
            v-if="product.errorMsg"
            class="h-font-size-s">
            {{ product.errorMsg }} (max. {{ product.quantity }})
          </div>
        </cell>

        <cell
          size="3"
          align-end
          :class="$style['cart-item__button-container']">
          <SlidingCheckbox
            data-test-id="merge-cart-item-checkbox"
            :checked="!forgetProducts.includes(product.pId)"
            checked-icon="System/check-line"
            @click.stop.prevent="handleClick(product.pId)" />
          <ProductPrice
            class="h-margin-top-s"
            :class="$style['cart-item__price']"
            :price="product.product?.price"
            :sale="product.product?.originalPrice" />
        </cell>
      </grid>
    </div>
  </div>
</template>
<script setup>
import getProductRoute from '~/helpers/get-product-route'
const config = useRuntimeConfig()
const cartStore = useCartStore()
const { forgetProducts } = storeToRefs(cartStore)

const props = defineProps({
  product: {
    type: Object,
    default: null
  },
  noBorder: {
    type: Boolean,
    default: true
  },
  noImage: {
    type: Boolean,
    default: false
  }
})

const imageUrl = computed(() => {
  if (!props.product.product?.images) { return false }
  return `${config.public.cdnURL}pictures/thumbs/${
        props.product.product.images[0]
      }-thumbnail.webp`
})

const forgetItem = pId => {
  console.log('forgetItem', pId)
  try {
    forgetProducts.value.push(pId)
  } catch (e) {
    console.error(e)
  }
}

const keepItem = pId => {
  try {
    forgetProducts.value.splice(forgetProducts.value.indexOf(pId), 1)
  } catch (e) {
    console.error(e)
  }
}

const handleClick = pId => {
  if (forgetProducts.value.includes(pId)) {
    keepItem(pId)
    return
  }
  forgetItem(pId)
}
</script>
<style lang="scss" module>
.cart-item {
  background-color: $white;
  color: $black;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  overflow: hidden;
  position: relative;
  border: 0;

  &__image {
    display: flex;
    padding: $spacing * 2;
    width: $spacing * 14;
    transition: .3s;

    .cart-item--compact & {
      padding: $spacing * 2;
      width: $spacing * 12;
      height: auto;
    }

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      border-radius: $border-radius;
    }
  }

  &__button-container {
    display: flex;
    flex-direction: column;
    gap: $spacing;
  }

  &__price,
  &__content-container {
    transition: .3s;
  }

  &__content {
    padding: $spacing * 2;
    padding-left: 0;
    flex: 1;

    .grid {
      height: 100%;
    }

    h4 {
      text-transform: none;
    }

    a {
      text-decoration: none;
      font-weight: $font-weight-bold;
    }

    .cart-item--compact & {
      padding: 0;
      padding-right: $spacing * 2;
      padding-top: $spacing * 2;
    }

    @media (max-width: #{$breakpoint-mobile}) {
      .grid {
        grid-gap: 10px;
      }
    }
  }

  &--faded {
    .cart-item__price,
    .cart-item__image,
    .cart-item__content-container {
      opacity: 0.4;
    }
  }

  @media screen and (prefers-color-scheme: darker) {
    background-color: $grey-darkest;
  }
}
</style>
